import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import _StatefulBase from '../_StatefulBase/_StatefulBase';


/**
 * Interface für das Widget das die Vererbungslinie angibt um die korrekten Typings zu setzen
 */
type _InputMultiBase__mdsbase = InstanceType<typeof _StatefulBase>;
interface _InputMultiBase extends _InputMultiBase__mdsbase { }
export default function _InputMultiBase(__Base: any) {
  const __C = 
class _InputMultiBase extends __Base {

    isMultiSelect: boolean;
    entries: Array<any>;
    selectedEntry: any;
    currentSelect: Array<any>;
    minCount: number;
    maxCount: number;



    ///////////////////

    getMultipleValues(): Array<any> {
        let values = new Array<any>();

        for (var value in this.currentSelect) {
            values.push(value);
        }

        return values;
    }

    setMultipleValues(values: Array<any>) {

        this.removeCurrentSelect();

        if (values.length > 0) {
            for (var i = 0; i < values.length; i++) {
                this.addSelect(values[i]);
            }
        }
    }

    addSelect(select:any): void {
        this.currentSelect[select] = select;
        this.addSelectLocal(select);
    }

    protected addSelectLocal(select?: any):void {
        // set the attribute "checked" in the child calss
    }

    removeCurrentSelect(): void {
        for (let select in this.currentSelect) {
            this.removeSelect(select);
        }

        this.removeCurrentSelectLocal();
    }

    removeCurrentSelectLocal(): void {
        // wird in der Kinderklasse ausprogrammiert
    }

    removeSelect(select):void {
        if (this.currentSelect[select]) {
            delete this.currentSelect[select];
        }
    }

    setMultiselect(value: boolean): void {
        this.removeCurrentSelect();
        this.isMultiSelect = value;
    }

    getMultiselect(): boolean {
        return this.isMultiSelect;
    }

   
    postCreate(): void {
        let self: any = this;
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        // required for dojo inheritance to call the superclass
        let self: any = this;
        super.startup.apply(this, arguments as any);
    }
}

;
Object.assign(__C.prototype, {
  isMultiSelect: false,
  declaredClass: '_InputMultiBase',
});
  return __C;
}
Object.assign(_InputMultiBase, { __mdsMixinFactory: true, __mdsSpineBases: [_StatefulBase] });